module.exports = __webpack_public_path__ + "img/ico-digital-platform_1.4334e5f0.svg";